import { api } from './api';
import { endpoints } from './endpoints';

const getCSEntries = (entryCode, params) =>
  api.get(endpoints.getCSEntries(entryCode), { params }).then(res => res.data);

export { getCSEntries };
